import { Controller, useForm } from 'react-hook-form'
import TimeField from 'react-simple-timefield'
import {
	FormContentSection,
	FormSectionCard,
	FormSectionTitle,
	GradientText,
	StyledTextArea,
	SubmitButton,
	SubmitButtonContainer,
} from '../../PasserCommande/PasserCommande.styles'
import React, { useRef, useState, useEffect } from 'react'
import toast from 'react-hot-toast'
import LayoutChauffeur from '../../../Components/LayoutChauffeur/LayoutChauffeur'
import UploadMultipleFiles from '../../../Components/UploadMultipleFiles/UploadMultipleFiles'
import { getSignalement, updateSignalement } from '../../../api/signalements'
import { useHistory } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getCommande } from '../../../api/commande'
import { deleteMultipleMedia } from '../../../api/upload'
import { useTranslation } from 'react-i18next'

function EditSignalement() {
	const history = useHistory()
	const { commande_id, signalement_id } = useParams()
	const [loading, setLoading] = useState(false)
	const [signalement, setSignalement] = useState(null)
	const [commande, setCommande] = useState(null)
	const [deletedFiles, setDeletedFiles] = useState([])
	const [chargementEnCours, setChargementEnCours] = useState(false)
	const { register, handleSubmit, watch, setValue, reset, control, formState: { errors } } = useForm()
	const token = useSelector((state) => state.auth.token)
    const {t} = useTranslation();
	const file = useRef()
	file.current = watch('file', null)

	const type = useRef()
	type.current = watch('type', '')

	useEffect(() => {
		async function _getSignalement(_id) {
			try {
				const data = await getSignalement(_id, token)
				setSignalement(data)

				// Extraire l'ID de course si c'est un objet
				const courseId = data.course?._id || data.course || ''

				reset({
					note: data.note,
					type: data.type,
					course: courseId,
					duration: data.duration,
					files: data.files || [],
				})
			} catch (error) {
				console.log(error)
			}
		}
		signalement_id && _getSignalement(signalement_id)

		async function _getCommande(_id) {
			setChargementEnCours(true)
			try {
				const data = await getCommande(_id, token)
				setCommande(data)
			} catch (error) {
				console.log(error)
			} finally {
				setChargementEnCours(false)
			}
		}
		_getCommande(commande_id)
	}, [commande_id, signalement_id, token, reset])

	const onSubmit = async (values) => {
		console.log("Valeurs du formulaire:", values)

		let data = { ...values }

		// Validation des champs conditionnels
		if (type.current === "retard_aux_chargement" || type.current === "retard_aux_déchargement") {
			if (!data.duration) {
				toast.error(t("enter_delay_time"), {
					style: { fontFamily: 'Montserrat' }
				})
				return
			}
		}

		if (type.current === "anomalie_course") {
			if (!data.course) {
				toast.error(t("select_trip_err"), {
					style: { fontFamily: 'Montserrat' }
				})
				return
			}
		}

		if (!data.files || data.files.length === 0) {
			toast.error(t("photo_required"), {
				style: { fontFamily: 'Montserrat' }
			})
			return
		}

		data.files = data.files.map((file) => file.id ?? file._id)

		const updateData = {
			files: data.files,
			type: data.type,
			note: data.note,
		}

		// Ajouter les champs conditionnels seulement s'ils sont présents
		if (data.duration) {
			updateData.duration = data.duration
		}
		if (data.course) {
			updateData.course = data.course
		}

		console.log("Données à envoyer:", updateData)

		setLoading(true)
		try {
			await updateSignalement(signalement_id, updateData, token)

			if (deletedFiles.length > 0) {
				await deleteMultipleMedia(deletedFiles)
			}

			toast.success(t("report_edited_successfully"), {
				style: { fontFamily: 'Montserrat' }
			})
			history.goBack()
		} catch (error) {
			console.error("Erreur lors de la mise à jour:", error)
			toast.error(t("transfer_request_err"), {
				style: { fontFamily: 'Montserrat' }
			})
		} finally {
			setLoading(false)
		}
	}

	const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);

	useEffect(() => {
		const checkScreen = () => {
			const width = window.innerWidth;

			setIsMobile(width <= 768);
		};
		checkScreen();
		window.addEventListener('resize', checkScreen);

		return () => window.removeEventListener('resize', checkScreen);
	}, []);
	return (
		<LayoutChauffeur>
			<div
				style={{
					width: '100%',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexDirection: 'column',
					paddingTop: '2rem',
					paddingBottom: '4rem',
					fontFamily: 'Montserrat',
					paddingLeft: '1.5rem',
					paddingRight: '1.5rem'
				}}
			>

				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<div
						onClick={() => history.goBack()}
						style={{
							background: '#51C7F2',
							width: isMobile ? '1.5rem' : '3rem',
							height: isMobile ? '1.5rem' : '3rem',
							borderRadius: '100%',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							cursor: 'pointer',
						}}
					>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width={14.017}
							height={14.11}
							viewBox='0 0 14.017 14.11'
						>
							<g data-name='Group 11287' fill='none' stroke='#fff' strokeWidth={2}>
								<path
									data-name='Path 11687'
									d='M16.6 11.818l-6.348 6.349 2.115 2.115 4.232 4.232'
									transform='translate(-8.838 -11.113)'
								/>
								<path
									data-name='Path 11688'
									d='M22.147 11.818l-6.348 6.349 6.348 6.348'
									transform='translate(-8.838 -11.113)'
								/>
							</g>
						</svg>
					</div>

					<div style={{ width: '1rem' }} />

					<GradientText marginTop={'unset'} style={{
						fontSize: isMobile ? '1.5rem' : '2.5rem'
					}}>
						{t("edit_report").toUpperCase()}
					</GradientText>
				</div>

				{chargementEnCours ? (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							backgroundColor: 'white',
							position: 'absolute',
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
						}}
					>
						<div className='customLoader'></div>
					</div>
				) : (
					<div style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						width: '100%',
					}}>
						<div style={{
							width: '100%',
							fontFamily: 'Montserrat',
							alignSelf: 'center',
						}}><form onSubmit={handleSubmit(onSubmit)}>


								<FormSectionCard>
									<div style={{ display: 'flex', flexDirection: 'column', marginBottom: '2rem' }}>
										<span
											style={{
												marginBottom: '1rem',
												color: 'black',
												fontSize: '14px',
												display: 'block',
												fontWeight: 'bold',
											}}
										>
											{t("select_anomaly_type")} <span style={{ color: 'red' }}>*</span>
										</span>

										<Controller
											name="type"
											control={control}
											rules={{ required: true }}
											defaultValue=""
											render={({ field }) => (
												<select
													{...field}
													style={{
														padding: '1rem',
														borderRadius: '0.5rem',
														color: '#858ea8',
														border: 'none',
														fontFamily: 'Montserrat',
														flex: '1',
														outline: 'none',
														width: '100%'
													}}
												>
													<option value="" disabled>{t("select_option")}</option>
													<option value="client_absent">Client absent</option>
													<option value="retard_aux_chargement">{t("loading_delay")}</option>
													<option value="livraison_reportée">{t("delivery_postponed")}</option>
													<option value="retard_aux_déchargement">{t("unloading_delay")}</option>
													<option value="marchandises_manquantes_chargement">{t("missing_goods")}</option>
													<option value="marchandise_refusée">{t("goods_refused" )}</option>
													<option value="marchandises_incomplètes">{t("incomplete_goods")}</option>
													<option value="marchandise_abîmée">{t("damaged_goods")}</option>
													<option value="route_inaccessible_fermée">{t("road_inaccessible")}</option>
													<option value="circulation_dense">{t("heavy_traffic")}</option>
													{commande?.type_commande === "course-a-course" && (
														<option value="anomalie_course">{t("trip_anomaly")}</option>
													)}
													<option value="autre">{t("other_specify")}</option>
												</select>
											)}
										/>
										{errors.type && (
											<p style={{ color: 'red', marginTop: '0.5rem' }}>
												{t("select_anomaly_type_err")}
											</p>
										)}
									</div>

									{/* SECTION RETARD (DURATION) */}
									{type.current && (type.current === "retard_aux_chargement" || type.current === "retard_aux_déchargement") && commande?.type_commande === "course-a-course" && (
										<div style={{ marginBottom: '2rem' }}>
											<p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
												{t("time_anomaly")}
											</p>
											<p style={{ marginBottom: '1rem' }}>
												{t("enter_delay_time_in_h&m")}{' '}
												<span style={{ color: 'red' }}>*</span>
											</p>
											<div
												style={{
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
												}}
											>
												<Controller
													name='duration'
													control={control}
													render={({ field: { onChange, value } }) => (
														<TimeField
															value={value}
															onChange={(event, value) => onChange(value)}
															input={
																<input
																	type='text'
																	className='date-input'
																	onFocus={(e) => e.target.select()}
																	style={{
																		padding: '1rem',
																		borderRadius: '0.5rem',
																		border: '1px solid #ccc',
																		fontFamily: 'Montserrat',
																		width: '100%',
																		outline: 'none',
																	}}
																/>
															}
															colon=':'
														/>
													)}
												/>
											</div>
											{errors.duration && (
												<p style={{ color: 'red', marginTop: '0.5rem' }}>
													{t("enter_delay_time")}
												</p>
											)}
										</div>
									)}

									{/* SECTION ANOMALIE COURSE */}
									{type.current && type.current === "anomalie_course" && commande?.type_commande === "course-a-course" && (
										<div style={{ marginBottom: '2rem' }}>
											<p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
												{t("trip_anomaly")}
											</p>
											<p style={{ marginBottom: '1rem' }}>
												{t("select_anomaly_trip")}{' '}
												<span style={{ color: 'red' }}>*</span>
											</p>
											<div
												style={{
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
												}}
											>
												<Controller
													name='course'
													control={control}
													render={({ field: { onChange, value } }) => {
														// Normaliser la valeur (extraire l'ID si c'est un objet)
														const normalizedValue = typeof value === 'object' && value?._id
															? value._id
															: value || ''

														return (
															<select
																value={normalizedValue}
																onChange={(e) => onChange(e.target.value)}
																style={{
																	padding: '1rem',
																	borderRadius: '0.5rem',
																	color: normalizedValue ? '#000' : '#858ea8',
																	border: 'none',
																	fontFamily: 'Montserrat',
																	flex: '1',
																	outline: 'none',
																	width: '100%'
																}}
															>
																<option value="">{t("select_trip")}</option>

																{/* Première course */}
																{commande?.courses?.[0] && (
																	<option value={commande.courses[0]._id}>
																		{`${"trip"} 1: ${commande.courses[0].adresse_debut?.label || ''} --> ${commande.courses[0].adresse_fin?.label || ''}`}
																	</option>
																)}

																{/* Deuxième course si exactement 2 courses */}
																{commande?.courses?.length === 2 && commande.courses[1] && (
																	<option value={commande.courses[1]._id}>
																		{`${"trip"} 2: ${commande.courses[0].adresse_fin?.label || ''} --> ${commande.courses[1].adresse?.label || ''}`}
																	</option>
																)}

																{/* Plus de 2 courses */}
																{commande?.courses?.length > 2 && (
																	<>
																		{/* Deuxième course */}
																		{commande.courses[1] && (
																			<option value={commande.courses[1]._id}>
																				{`${"trip"} 2: ${commande.courses[0].adresse_fin?.label || ''} --> ${commande.courses[1].adresse?.label || ''}`}
																			</option>
																		)}

																		{/* Courses suivantes */}
																		{commande.courses.map((course, index) => (
																			index > 1 && (
																				<option key={course._id} value={course._id}>
																					{`${"trip"} ${index + 1}: ${commande.courses[index - 1]?.adresse?.label || ''} --> ${course.adresse?.label || ''}`}
																				</option>
																			)
																		))}
																	</>
																)}
															</select>
														)
													}}
												/>
											</div>
											{errors.course && (
												<p style={{ color: 'red', marginTop: '0.5rem' }}>
													{t("select_trip_err")}
												</p>
											)}
										</div>
									)}
								</FormSectionCard>

								<div style={{ height: '1rem' }} />

								<FormSectionCard>
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											marginBottom: '2.5rem',
											width: '100%',
										}}
									>
										<span
											style={{
												marginBottom: '1rem',
												color: 'black',
												fontSize: 14,
												fontWeight: 'bold',
											}}
										>
											Note <span style={{ color: 'red' }}>*</span>
										</span>
										<StyledTextArea
											type='text'
											rows={4}
											placeholder=''
											{...register('note', { required: true })}
										/>
										{errors.note && (
											<p style={{ color: 'red', marginTop: '0.5rem' }}>
												{t("enter_note_err")}
											</p>
										)}
									</div>

									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											marginBottom: '1rem',
											width: isMobile? '100%' :'50%',
											fontFamily: 'Montserrat',
										}}
									>
										<div
											style={{
												display: 'flex',
												flexDirection: 'row',
												justifyContent: 'space-between',
											}}
										>
											<span
												style={{
													marginBottom: '1rem',
													color: 'black',
													fontSize: 14,
													fontWeight: 'bold',
												}}
											>
												{t("attach_images/pdf")} <span style={{ color: 'red' }}>*</span>
											</span>
										</div>
										{signalement && commande && (
											<UploadMultipleFiles
												name='files'
												initialFiles={signalement.files}
												onChange={(files) => {
													console.log("Fichiers mis à jour:", files)
													setValue('files', files)
												}}
												id={commande._id}
												setDeletedFiles={setDeletedFiles}
											/>
										)}
									</div>
								</FormSectionCard>


								<div style={{ height: '1rem' }} />
								<SubmitButtonContainer>
									<SubmitButton type='submit' disabled={loading}>
										{loading ? (
											<div className='loader'></div>
										) : (
											t("save")
										)}
									</SubmitButton>
								</SubmitButtonContainer>
							</form>
						</div>
					</div>
				)}

			</div>
		</LayoutChauffeur>
	)
}

export default EditSignalement